import {OUTLOOK_CONFIG_CONSTANT} from '../constants/OutlookConfigConstants'

const initialState = {
};

const OutlookConfigReducer = (state = initialState, action) => {
    switch (action.type) {
        case OUTLOOK_CONFIG_CONSTANT.LOAD_OUTLOOK_WORKREQUEST_CONFIG:
            return {
                ...state,
                outlookConfig: action.payload.data
            };
        case OUTLOOK_CONFIG_CONSTANT.UPDATE_WORKREQUEST_DATA:
            return {
                ...state,
                outlookConfig: action.payload.data
            }
        default:
            return state;
    }
};

export default OutlookConfigReducer;